import * as React from 'react';
import { ThemeModeContext } from './ThemeModeProvider';

export const useThemeModeContext = () => {
  const context = React.useContext(ThemeModeContext);
  if (context === undefined) {
    throw new Error('useThemeModeContext must be used within a ThemeModeProvider');
  }
  return context;
};

export default useThemeModeContext;
